import { buildOrganizationSchema } from '../types/Organization'

/**
 * Generates Organization schema for LandingPage (Homepage)
 * @param {Object} data - Page data object
 * @param {Object} header - Header data object
 * @param {Object} footer - Footer data object
 * @returns {Object|null} Organization schema object
 */
export default function LandingPageSchema(data, header, footer) {
    if (!data) {
        return null
    }

    // Extract URL from data.Url if available, otherwise use hardcoded
    let url = data.Url?.Href || "https://www.wellbyfinancial.com/"
    if (!url.startsWith('http') && typeof window !== 'undefined') {
        url = window.location.origin + (url.startsWith('/') ? url : '/' + url)
    }

    // Extract Logo URL from CMS
    let logo = null
    if (header && header.LogoImage && header.LogoImage.Url) {
        logo = header.LogoImage.Url
        // Ensure logo URL is absolute
        if (logo.startsWith('/') && typeof window !== 'undefined') {
            logo = window.location.origin + logo
        }
    }

    // Extract Social Links from footer CMS
    let socialLinks = []
    if (footer && footer.SocialLinks && Array.isArray(footer.SocialLinks)) {
        socialLinks = footer.SocialLinks.map(link => link.Link || link.Url || link.href).filter(Boolean)
    }

    // Build the Organization schema with hardcoded and CMS values
    return buildOrganizationSchema({
        name: "Wellby Financial Credit Union",
        url: url,
        logo: logo,
        description: data.MetaDescription || "Wellby Financial helps Houstonians and beyond achieve financial prosperity with checking, savings, loans, mortgages, and wealth planning designed for you.",
        areaServed: "Houston, TX",
        socialLinks: socialLinks,
        contactPoints: [
            {
                telephone: "+1 (281) 488-7070",
                email: "support@wellbyfinancial.com",
                contactType: "Customer Support"
            },
            {
                telephone: "+1 (800) 940-0708",
                email: "support@wellbyfinancial.com",
                contactType: "Customer Support"
            }
        ]
    })
}
